// extracted by mini-css-extract-plugin
export default {"statistic":"PeopleStatistic_statistic__eH4b7"};